function qtyValueChange(t, e) {
  return (
    "plus" === e.dataset.operation
      ? (t = parseInt(t) + 1)
      : 1 < t && (t = parseInt(t) - 1),
    t
  );
}
function initAccordion(t) {
  document.querySelector(t) &&
    document.querySelectorAll(t).forEach((n) => {
      n.querySelectorAll(".accordion__head").forEach((e) => {
        e.addEventListener("click", function (t) {
          n
            .querySelectorAll(".accordion__section")
            .forEach((t) =>
              t !== e.closest(".accordion__section")
                ? t.classList.remove("is-active")
                : ""
            ),
            e.closest(".accordion__section").classList.toggle("is-active"),
            window.innerWidth < 768 &&
              setTimeout(() => {
                window.scrollTo({
                  top:
                    e.offsetTop -
                    document.querySelector(".banner-product").offsetHeight -
                    20,
                  left: 0,
                  behavior: "smooth",
                });
              }, 400),
            t.preventDefault();
        });
      });
    });
}
function validateEmail(t) {
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    String(t).toLowerCase()
  );
}
function initSearchOpener() {
  const e = document.querySelector(".header-search-wrap");
  var t = document.querySelector(".icon-search"),
    n = document.querySelector(".search-close");
  document
    .querySelector(".js-input-clear")
    .addEventListener("click", function () {
      this.parentNode.querySelector("input").value = "";
    }),
    t.addEventListener("click", (t) => {
      t.preventDefault(),
        $("body").hasClass("hs-active") && $("body").removeClass("hs-active"),
        e.classList.add("search-active"),
        $("#input-search-form").focus();
    }),
    n.addEventListener("click", () => {
      e.classList.remove("search-active");
    });
}
document.querySelectorAll(".js-expand-content").forEach((e) => {
  e.addEventListener("click", function (t) {
    e.closest(".js-expandable")?.classList.toggle("is-open"),
      e.closest(".js-expandable").classList.contains("is-open")
        ? (e.innerHTML = "Read Less -")
        : (e.innerHTML = "Read More +"),
      t.preventDefault();
  });
}),
  document.querySelectorAll(".js-popup-open").forEach((n) => {
    n.addEventListener("click", function (t) {
      var e = n.getAttribute("href");
      e &&
        ((e = document.querySelector(e)).classList.add("is-active"),
        document.querySelector("body").classList.add("has-popup-open"),
        e.querySelector("video") && e.querySelector("video").play(),
        t.preventDefault());
    });
  }),
  document.querySelectorAll(".js-popup-close").forEach((n) => {
    n.addEventListener("click", function (t) {
      var e;
      n.closest(".js-popup") &&
        ((e = n.closest(".js-popup")).classList.remove("is-active"),
        document.querySelector("body").classList.remove("has-popup-open"),
        e.querySelector("video") &&
          (e.querySelector("video").pause(),
          (e.querySelector("video").currentTime = 0)),
        t.preventDefault());
    });
  }),
  document.querySelectorAll(".js-quantity").forEach((t) => {
    const n = t.querySelector("input");
    t.querySelectorAll("button").forEach((e) => {
      e.addEventListener("click", function () {
        var t = n.value;
        n.value = qtyValueChange(t, e);
      });
    });
  }),
  document.querySelectorAll("li.menu-item-has-children").forEach((t) => {
    t.addEventListener("mouseenter", function () {
      document.querySelector("body").classList.add("has-dropdown-open");
    }),
      t.addEventListener("mouseleave", function () {
        document.querySelector("body").classList.remove("has-dropdown-open");
      });
  }),
  document
    .querySelector(".js-menu-toggle")
    .addEventListener("click", function (t) {
      document.querySelector(".js-menu-toggle").classList.toggle("is-active"),
        document.querySelector(".js-menu").classList.toggle("is-active"),
        document.querySelector(".header").classList.toggle("has-menu-open"),
        document.querySelector("body").classList.toggle("has-dropdown-open"),
        t.preventDefault();
    }),
  document.querySelectorAll("li.menu-item-has-children > a").forEach((e) => {
    e.addEventListener("click", function (t) {
      e.parentNode.classList.toggle("is-open"), t.preventDefault();
    });
  }),
  initAccordion(".js-accordion"),
  document.querySelectorAll(".js-video-play").forEach((e) => {
    e.addEventListener("click", function (t) {
      e.classList.toggle("is-playing"),
        e.classList.contains("is-playing")
          ? e.querySelector("video").play()
          : (e.querySelector("video").pause(),
            (e.querySelector("video").currentTime = 0)),
        t.preventDefault();
    });
  }),
  document.querySelectorAll(".js-video-player").forEach((e) => {
    e.querySelector(".js-mute").addEventListener("click", function (t) {
      e.querySelector(".js-mute").classList.toggle("is-muted"),
        e.querySelector(".js-mute").classList.contains("is-muted")
          ? (e.querySelector("video").muted = !0)
          : (e.querySelector("video").muted = !1),
        t.preventDefault();
    });
  }),
  function () {
    function i(t, e, n, i) {
      return new r(t, e, n, i);
    }
    function r(t, e, n, i) {
      (this.options = i || {}),
        (this.options.adapters = this.options.adapters || {}),
        (this.obj = t),
        (this.keypath = e),
        (this.callback = n),
        (this.objectPath = []),
        (this.update = this.update.bind(this)),
        this.parse(),
        s((this.target = this.realize())) &&
          this.set(!0, this.key, this.target, this.callback);
    }
    function s(t) {
      return "object" == typeof t && null !== t;
    }
    function o(t) {
      throw new Error("[sightglass] " + t);
    }
    (i.adapters = {}),
      (r.tokenize = function (t, e, n) {
        for (var i, r = [], s = { i: n, path: "" }, o = 0; o < t.length; o++)
          (i = t.charAt(o)),
            ~e.indexOf(i)
              ? (r.push(s), (s = { i: i, path: "" }))
              : (s.path += i);
        return r.push(s), r;
      }),
      (r.prototype.parse = function () {
        var t,
          e,
          n = this.interfaces();
        n.length || o("Must define at least one adapter interface."),
          (e = ~n.indexOf(this.keypath[0])
            ? ((t = this.keypath[0]), this.keypath.substr(1))
            : (void 0 === (t = this.options.root || i.root) &&
                o("Must define a default root adapter."),
              this.keypath)),
          (this.tokens = r.tokenize(e, n, t)),
          (this.key = this.tokens.pop());
      }),
      (r.prototype.realize = function () {
        var n,
          i = this.obj,
          r = !1;
        return (
          this.tokens.forEach(function (t, e) {
            s(i)
              ? (void 0 !== this.objectPath[e]
                  ? i !== (n = this.objectPath[e]) &&
                    (this.set(!1, t, n, this.update),
                    this.set(!0, t, i, this.update),
                    (this.objectPath[e] = i))
                  : (this.set(!0, t, i, this.update), (this.objectPath[e] = i)),
                (i = this.get(t, i)))
              : (!1 === r && (r = e),
                (n = this.objectPath[e]) && this.set(!1, t, n, this.update));
          }, this),
          !1 !== r && this.objectPath.splice(r),
          i
        );
      }),
      (r.prototype.update = function () {
        var t, e;
        (t = this.realize()) !== this.target &&
          (s(this.target) && this.set(!1, this.key, this.target, this.callback),
          s(t) && this.set(!0, this.key, t, this.callback),
          (e = this.value()),
          (this.target = t),
          this.value() instanceof Function || this.value() !== e) &&
          this.callback();
      }),
      (r.prototype.value = function () {
        return s(this.target) ? this.get(this.key, this.target) : void 0;
      }),
      (r.prototype.setValue = function (t) {
        s(this.target) &&
          this.adapter(this.key).set(this.target, this.key.path, t);
      }),
      (r.prototype.get = function (t, e) {
        return this.adapter(t).get(e, t.path);
      }),
      (r.prototype.set = function (t, e, n, i) {
        t = t ? "observe" : "unobserve";
        this.adapter(e)[t](n, e.path, i);
      }),
      (r.prototype.interfaces = function () {
        var e = Object.keys(this.options.adapters);
        return (
          Object.keys(i.adapters).forEach(function (t) {
            ~e.indexOf(t) || e.push(t);
          }),
          e
        );
      }),
      (r.prototype.adapter = function (t) {
        return this.options.adapters[t.i] || i.adapters[t.i];
      }),
      (r.prototype.unobserve = function () {
        var n;
        this.tokens.forEach(function (t, e) {
          (n = this.objectPath[e]) && this.set(!1, t, n, this.update);
        }, this),
          s(this.target) && this.set(!1, this.key, this.target, this.callback);
      }),
      "undefined" != typeof module && module.exports
        ? (module.exports = i)
        : "function" == typeof define && define.amd
        ? define([], function () {
            return (this.sightglass = i);
          })
        : (this.sightglass = i);
  }.call(this),
  function () {
    function y(t, e) {
      return function () {
        return t.apply(e, arguments);
      };
    }
    function t(t, e) {
      function n() {
        this.constructor = t;
      }
      for (var i in e) s.call(e, i) && (t[i] = e[i]);
      (n.prototype = e.prototype),
        (t.prototype = new n()),
        (t.__super__ = e.prototype);
    }
    var j,
      i,
      r,
      e,
      n,
      f = [].slice,
      s = {}.hasOwnProperty,
      d =
        [].indexOf ||
        function (t) {
          for (var e = 0, n = this.length; e < n; e++)
            if (e in this && this[e] === t) return e;
          return -1;
        };
    function o(t, e, n, i, r) {
      (this.view = t),
        (this.el = e),
        (this.type = n),
        (this.keypath = i),
        (this.options = null != r ? r : {}),
        (this.sync = y(this.sync, this)),
        (this.formatters = this.options.formatters || []),
        (this.dependencies = []),
        (this.formatterObservers = {});
    }
    function a(t, e, n) {
      var i, r, s, o, a, u, l;
      for (
        this.view = t,
          this.el = e,
          this.type = n,
          this.unbind = y(this.unbind, this),
          this.bind = y(this.bind, this),
          this.locals = y(this.locals, this),
          this.component = this.view.components[this.type],
          this.static = {},
          this.observers = {},
          this.upstreamObservers = {},
          r = t.bindingRegExp(),
          o = 0,
          a = (u = this.el.attributes || []).length;
        o < a;
        o++
      )
        (i = u[o]),
          r.test(i.name) ||
            ((s = this.camelCase(i.name)),
            0 <= d.call(null != (l = this.component.static) ? l : [], s)
              ? (this.static[s] = i.value)
              : (this.observers[s] = i.value));
    }
    function u(t, e, n, i, r) {
      (this.view = t),
        (this.el = e),
        (this.type = n),
        (this.keypath = i),
        (this.options = null != r ? r : {}),
        (this.getValue = y(this.getValue, this)),
        (this.update = y(this.update, this)),
        (this.unbind = y(this.unbind, this)),
        (this.bind = y(this.bind, this)),
        (this.publish = y(this.publish, this)),
        (this.sync = y(this.sync, this)),
        (this.set = y(this.set, this)),
        (this.eventHandler = y(this.eventHandler, this)),
        (this.formattedValue = y(this.formattedValue, this)),
        (this.parseTarget = y(this.parseTarget, this)),
        (this.observe = y(this.observe, this)),
        (this.setBinder = y(this.setBinder, this)),
        (this.formatters = this.options.formatters || []),
        (this.dependencies = []),
        (this.formatterObservers = {}),
        (this.model = void 0),
        this.setBinder();
    }
    function l(t, e, n) {
      var i, r, s, o, a, u, l, c, d, h, p, f, v;
      for (
        this.els = t,
          this.models = e,
          null == n && (n = {}),
          this.update = y(this.update, this),
          this.publish = y(this.publish, this),
          this.sync = y(this.sync, this),
          this.unbind = y(this.unbind, this),
          this.bind = y(this.bind, this),
          this.select = y(this.select, this),
          this.traverse = y(this.traverse, this),
          this.build = y(this.build, this),
          this.buildBinding = y(this.buildBinding, this),
          this.bindingRegExp = y(this.bindingRegExp, this),
          this.options = y(this.options, this),
          this.els.jquery ||
            this.els instanceof Array ||
            (this.els = [this.els]),
          a = 0,
          l = (d = j.extensions).length;
        a < l;
        a++
      ) {
        if (((this[(r = d[a])] = {}), n[r]))
          for (i in (h = n[r])) (s = h[i]), (this[r][i] = s);
        for (i in (p = j.public[r]))
          (s = p[i]), null == (o = this[r])[i] && (o[i] = s);
      }
      for (u = 0, c = (f = j.options).length; u < c; u++)
        this[(r = f[u])] = null != (v = n[r]) ? v : j.public[r];
      this.build();
    }
    function c() {}
    function h() {}
    (j = {
      options: [
        "prefix",
        "templateDelimiters",
        "rootInterface",
        "preloadData",
        "handler",
      ],
      extensions: ["binders", "formatters", "components", "adapters"],
      public: {
        binders: {},
        components: {},
        formatters: {},
        adapters: {},
        prefix: "rv",
        templateDelimiters: ["{", "}"],
        rootInterface: ".",
        preloadData: !0,
        handler: function (t, e, n) {
          return this.call(t, e, n.view.models);
        },
        configure: function (t) {
          var e, n, i, r;
          for (i in (t = null == t ? {} : t))
            if (
              ((r = t[i]),
              "binders" === i ||
                "components" === i ||
                "formatters" === i ||
                "adapters" === i)
            )
              for (n in r) (e = r[n]), (j[i][n] = e);
            else j.public[i] = r;
        },
        bind: function (t, e, n) {
          return (
            (t = new j.View(
              t,
              (e = null == e ? {} : e),
              (n = null == n ? {} : n)
            )).bind(),
            t
          );
        },
        init: function (t, e, n) {
          return (
            null == n && (n = {}),
            null == e && (e = document.createElement("div")),
            (t = j.public.components[t]),
            (e.innerHTML = t.template.call(this, e)),
            (t = t.initialize.call(this, e, n)),
            (n = new j.View(e, t)).bind(),
            n
          );
        },
      },
    }),
      window.jQuery || window.$
        ? ((n = "on" in jQuery.prototype ? ["on", "off"] : ["bind", "unbind"]),
          (i = n[0]),
          (r = n[1]),
          (j.Util = {
            bindEvent: function (t, e, n) {
              return jQuery(t)[i](e, n);
            },
            unbindEvent: function (t, e, n) {
              return jQuery(t)[r](e, n);
            },
            getInputValue: function (t) {
              t = jQuery(t);
              return "checkbox" === t.attr("type") ? t.is(":checked") : t.val();
            },
          }))
        : (j.Util = {
            bindEvent:
              "addEventListener" in window
                ? function (t, e, n) {
                    return t.addEventListener(e, n, !1);
                  }
                : function (t, e, n) {
                    return t.attachEvent("on" + e, n);
                  },
            unbindEvent:
              "removeEventListener" in window
                ? function (t, e, n) {
                    return t.removeEventListener(e, n, !1);
                  }
                : function (t, e, n) {
                    return t.detachEvent("on" + e, n);
                  },
            getInputValue: function (t) {
              var e, n, i, r;
              if ("checkbox" === t.type) return t.checked;
              if ("select-multiple" !== t.type) return t.value;
              for (r = [], n = 0, i = t.length; n < i; n++)
                (e = t[n]).selected && r.push(e.value);
              return r;
            },
          }),
      (j.TypeParser =
        ((h.types = { primitive: 0, keypath: 1 }),
        (h.parse = function (t) {
          return /^'.*'$|^".*"$/.test(t)
            ? { type: this.types.primitive, value: t.slice(1, -1) }
            : "true" === t
            ? { type: this.types.primitive, value: !0 }
            : "false" === t
            ? { type: this.types.primitive, value: !1 }
            : "null" === t
            ? { type: this.types.primitive, value: null }
            : "undefined" === t
            ? { type: this.types.primitive, value: void 0 }
            : !1 === isNaN(Number(t))
            ? { type: this.types.primitive, value: Number(t) }
            : { type: this.types.keypath, value: t };
        }),
        h)),
      (j.TextTemplateParser =
        ((c.types = { text: 0, binding: 1 }),
        (c.parse = function (t, e) {
          for (var n, i, r, s = [], o = t.length, a = 0; a < o; ) {
            if ((r = t.indexOf(e[0], a)) < 0) {
              s.push({ type: this.types.text, value: t.slice(a) });
              break;
            }
            if (
              (0 < r &&
                a < r &&
                s.push({ type: this.types.text, value: t.slice(a, r) }),
              (a = r + e[0].length),
              (r = t.indexOf(e[1], a)) < 0)
            ) {
              (n = t.slice(a - e[1].length)),
                (null != (i = s[s.length - 1]) ? i.type : void 0) ===
                this.types.text
                  ? (i.value += n)
                  : s.push({ type: this.types.text, value: n });
              break;
            }
            (i = t.slice(a, r).trim()),
              s.push({ type: this.types.binding, value: i }),
              (a = r + e[1].length);
          }
          return s;
        }),
        c)),
      (j.View =
        ((l.prototype.options = function () {
          for (
            var t,
              e = {},
              n = j.extensions.concat(j.options),
              i = 0,
              r = n.length;
            i < r;
            i++
          )
            e[(t = n[i])] = this[t];
          return e;
        }),
        (l.prototype.bindingRegExp = function () {
          return new RegExp("^" + this.prefix + "-");
        }),
        (l.prototype.buildBinding = function (t, e, n, r) {
          var s,
            o,
            i = {},
            a = (function () {
              for (
                var t = r.split("|"), e = [], n = 0, i = t.length;
                n < i;
                n++
              )
                (o = t[n]), e.push(o.trim());
              return e;
            })(),
            u = (function () {
              for (
                var t = a.shift().split("<"), e = [], n = 0, i = t.length;
                n < i;
                n++
              )
                (s = t[n]), e.push(s.trim());
              return e;
            })(),
            l = u.shift();
          return (
            (i.formatters = a),
            (u = u.shift()) && (i.dependencies = u.split(/\s+/)),
            this.bindings.push(new j[t](this, e, n, l, i))
          );
        }),
        (l.prototype.build = function () {
          var t, v, e, n, i, y;
          for (
            this.bindings = [],
              v = function (r) {
                var t, e, n, s, i, o, a, u, l, c, d, h, p, f;
                if (3 === r.nodeType) {
                  if (
                    ((i = j.TextTemplateParser),
                    (n = y.templateDelimiters) &&
                      (u = i.parse(r.data, n)).length &&
                      (1 !== u.length || u[0].type !== i.types.text))
                  ) {
                    for (l = 0, d = u.length; l < d; l++)
                      (a = u[l]),
                        (o = document.createTextNode(a.value)),
                        r.parentNode.insertBefore(o, r),
                        1 === a.type &&
                          y.buildBinding("TextBinding", o, null, a.value);
                    r.parentNode.removeChild(r);
                  }
                } else 1 === r.nodeType && (t = y.traverse(r));
                if (!t) {
                  for (
                    f = [],
                      c = 0,
                      h = (p = (function () {
                        for (
                          var t = r.childNodes, e = [], n = 0, i = t.length;
                          n < i;
                          n++
                        )
                          (s = t[n]), e.push(s);
                        return e;
                      })()).length;
                    c < h;
                    c++
                  )
                    (e = p[c]), f.push(v(e));
                  return f;
                }
              },
              e = 0,
              n = (i = (y = this).els).length;
            e < n;
            e++
          )
            (t = i[e]), v(t);
          this.bindings.sort(function (t, e) {
            return (
              ((null != (e = e.binder) ? e.priority : void 0) || 0) -
              ((null != (e = t.binder) ? e.priority : void 0) || 0)
            );
          });
        }),
        (l.prototype.traverse = function (t) {
          for (
            var e,
              n,
              i,
              r,
              s,
              o,
              a,
              u,
              l,
              c,
              d,
              h = this.bindingRegExp(),
              p = "SCRIPT" === t.nodeName || "STYLE" === t.nodeName,
              f = t.attributes,
              v = 0,
              y = f.length;
            v < y;
            v++
          )
            if (((e = f[v]), h.test(e.name))) {
              if (((o = e.name.replace(h, "")), !(i = this.binders[o])))
                for (r in (c = this.binders))
                  (a = c[r]),
                    "*" !== r &&
                      -1 !== r.indexOf("*") &&
                      ((s = new RegExp("^" + r.replace(/\*/g, ".+") + "$")),
                      s.test(o)) &&
                      (i = a);
              (i = i || this.binders["*"]).block && ((p = !0), (n = [e]));
            }
          for (u = 0, l = (d = n || t.attributes).length; u < l; u++)
            (e = d[u]),
              h.test(e.name) &&
                ((o = e.name.replace(h, "")),
                this.buildBinding("Binding", t, o, e.value));
          return (
            p ||
              ((o = t.nodeName.toLowerCase()),
              this.components[o] &&
                !t._bound &&
                (this.bindings.push(new j.ComponentBinding(this, t, o)),
                (p = !0))),
            p
          );
        }),
        (l.prototype.select = function (t) {
          for (
            var e, n = this.bindings, i = [], r = 0, s = n.length;
            r < s;
            r++
          )
            t((e = n[r])) && i.push(e);
          return i;
        }),
        (l.prototype.bind = function () {
          for (
            var t, e = this.bindings, n = [], i = 0, r = e.length;
            i < r;
            i++
          )
            (t = e[i]), n.push(t.bind());
          return n;
        }),
        (l.prototype.unbind = function () {
          for (
            var t, e = this.bindings, n = [], i = 0, r = e.length;
            i < r;
            i++
          )
            (t = e[i]), n.push(t.unbind());
          return n;
        }),
        (l.prototype.sync = function () {
          for (
            var t, e = this.bindings, n = [], i = 0, r = e.length;
            i < r;
            i++
          )
            (t = e[i]), n.push("function" == typeof t.sync ? t.sync() : void 0);
          return n;
        }),
        (l.prototype.publish = function () {
          for (
            var t,
              e = this.select(function (t) {
                return null != (t = t.binder) ? t.publishes : void 0;
              }),
              n = [],
              i = 0,
              r = e.length;
            i < r;
            i++
          )
            (t = e[i]), n.push(t.publish());
          return n;
        }),
        (l.prototype.update = function (t) {
          var e, n, i, r, s, o, a;
          for (n in (t = null == t ? {} : t)) (i = t[n]), (this.models[n] = i);
          for (a = [], r = 0, s = (o = this.bindings).length; r < s; r++)
            (e = o[r]),
              a.push("function" == typeof e.update ? e.update(t) : void 0);
          return a;
        }),
        l)),
      (j.Binding =
        ((u.prototype.setBinder = function () {
          var t, e, n, i;
          if (!(this.binder = this.view.binders[this.type]))
            for (t in (i = this.view.binders))
              (n = i[t]),
                "*" !== t &&
                  -1 !== t.indexOf("*") &&
                  ((e = new RegExp("^" + t.replace(/\*/g, ".+") + "$")),
                  e.test(this.type)) &&
                  ((this.binder = n),
                  (this.args = new RegExp(
                    "^" + t.replace(/\*/g, "(.+)") + "$"
                  ).exec(this.type)),
                  this.args.shift());
          return (
            this.binder || (this.binder = this.view.binders["*"]),
            this.binder instanceof Function
              ? (this.binder = { routine: this.binder })
              : void 0
          );
        }),
        (u.prototype.observe = function (t, e, n) {
          return j.sightglass(t, e, n, {
            root: this.view.rootInterface,
            adapters: this.view.adapters,
          });
        }),
        (u.prototype.parseTarget = function () {
          var t = j.TypeParser.parse(this.keypath);
          return 0 === t.type
            ? (this.value = t.value)
            : ((this.observer = this.observe(
                this.view.models,
                this.keypath,
                this.sync
              )),
              (this.model = this.observer.target));
        }),
        (u.prototype.formattedValue = function (t) {
          for (
            var e,
              i,
              r,
              n,
              s,
              o,
              a,
              u,
              l,
              c,
              d = this.formatters,
              h = (u = 0),
              p = d.length;
            u < p;
            h = ++u
          ) {
            for (
              n = d[h],
                s = (r = n.match(
                  /[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g
                )).shift(),
                n = this.view.formatters[s],
                o = [],
                e = l = 0,
                c = (r = (function () {
                  for (var t = [], e = 0, n = r.length; e < n; e++)
                    (i = r[e]), t.push(j.TypeParser.parse(i));
                  return t;
                })()).length;
              l < c;
              e = ++l
            )
              (i = r[e]),
                o.push(
                  0 === i.type
                    ? i.value
                    : ((a = this.formatterObservers)[h] || (a[h] = {}),
                      (a = this.formatterObservers[h][e]) ||
                        ((a = this.observe(
                          this.view.models,
                          i.value,
                          this.sync
                        )),
                        (this.formatterObservers[h][e] = a)),
                      a.value())
                );
            (null != n ? n.read : void 0) instanceof Function
              ? (t = n.read.apply(n, [t].concat(f.call(o))))
              : n instanceof Function &&
                (t = n.apply(null, [t].concat(f.call(o))));
          }
          return t;
        }),
        (u.prototype.eventHandler = function (e) {
          var n,
            i = (n = this).view.handler;
          return function (t) {
            return i.call(e, this, t, n);
          };
        }),
        (u.prototype.set = function (t) {
          var e;
          return (
            (t = this.formattedValue(
              t instanceof Function && !this.binder.function
                ? t.call(this.model)
                : t
            )),
            null != (e = this.binder.routine)
              ? e.call(this, this.el, t)
              : void 0
          );
        }),
        (u.prototype.sync = function () {
          var a, u;
          return this.set(
            function () {
              var t, e, n, i, r, s, o;
              if (this.observer) {
                if (this.model !== this.observer.target) {
                  for (t = 0, n = (r = this.dependencies).length; t < n; t++)
                    (u = r[t]).unobserve();
                  if (
                    ((this.dependencies = []),
                    null != (this.model = this.observer.target) &&
                      null != (s = this.options.dependencies) &&
                      s.length)
                  )
                    for (
                      e = 0, i = (o = this.options.dependencies).length;
                      e < i;
                      e++
                    )
                      (a = o[e]),
                        (u = this.observe(this.model, a, this.sync)),
                        this.dependencies.push(u);
                }
                return this.observer.value();
              }
              return this.value;
            }.call(this)
          );
        }),
        (u.prototype.publish = function () {
          var t, e, n, i, r, s, o;
          if (this.observer) {
            for (
              n = this.getValue(this.el),
                r = (s = this.formatters.slice((i = 0)).reverse()).length;
              i < r;
              i++
            )
              (e = (t = s[i].split(/\s+/)).shift()),
                null != (o = this.view.formatters[e]) &&
                  o.publish &&
                  (n = (o = this.view.formatters[e]).publish.apply(
                    o,
                    [n].concat(f.call(t))
                  ));
            return this.observer.setValue(n);
          }
        }),
        (u.prototype.bind = function () {
          var t, e, n, i, r;
          if (
            (this.parseTarget(),
            null != (i = this.binder.bind) && i.call(this, this.el),
            null != this.model &&
              null != (i = this.options.dependencies) &&
              i.length)
          )
            for (e = 0, n = (r = this.options.dependencies).length; e < n; e++)
              (t = r[e]),
                (t = this.observe(this.model, t, this.sync)),
                this.dependencies.push(t);
          return this.view.preloadData ? this.sync() : void 0;
        }),
        (u.prototype.unbind = function () {
          var t, e, n, i, r, s, o, a, u;
          for (
            null != (o = this.binder.unbind) && o.call(this, this.el),
              null != (o = this.observer) && o.unobserve(),
              r = 0,
              s = (a = this.dependencies).length;
            r < s;
            r++
          )
            (i = a[r]).unobserve();
          for (n in ((this.dependencies = []), (u = this.formatterObservers)))
            for (t in (e = u[n])) (i = e[t]), i.unobserve();
          return (this.formatterObservers = {});
        }),
        (u.prototype.update = function (t) {
          var e;
          return (
            null == t && (t = {}),
            (this.model = null != (e = this.observer) ? e.target : void 0),
            null != (e = this.binder.update) ? e.call(this, t) : void 0
          );
        }),
        (u.prototype.getValue = function (t) {
          return this.binder && null != this.binder.getValue
            ? this.binder.getValue.call(this, t)
            : j.Util.getInputValue(t);
        }),
        u)),
      (j.ComponentBinding =
        ((n = j.Binding),
        t(a, n),
        (a.prototype.sync = function () {}),
        (a.prototype.update = function () {}),
        (a.prototype.publish = function () {}),
        (a.prototype.locals = function () {
          var t,
            e,
            n,
            i,
            r = {},
            s = this.static;
          for (t in s) (n = s[t]), (r[t] = n);
          for (t in (i = this.observers)) (e = i[t]), (r[t] = e.value());
          return r;
        }),
        (a.prototype.camelCase = function (t) {
          return t.replace(/-([a-z])/g, function (t) {
            return t[1].toUpperCase();
          });
        }),
        (a.prototype.bind = function () {
          var t, e, n, i, r, s, o, a, u, l, c, d, h, p, f, v, y, m, g, b, w;
          if (!this.bound) {
            for (e in (p = this.observers))
              (n = p[e]),
                (this.observers[e] = this.observe(
                  this.view.models,
                  n,
                  (function (e) {
                    return function (t) {
                      return function () {
                        return (e.componentView.models[t] =
                          e.observers[t].value());
                      };
                    };
                  })(this).call(this, e)
                ));
            this.bound = !0;
          }
          if (null != this.componentView) return this.componentView.bind();
          for (
            this.el.innerHTML = this.component.template.call(this),
              o = this.component.initialize.call(this, this.el, this.locals()),
              this.el._bound = !0,
              s = {},
              l = 0,
              d = (f = j.extensions).length;
            l < d;
            l++
          ) {
            if (((s[(r = f[l])] = {}), this.component[r]))
              for (t in (v = this.component[r])) (a = v[t]), (s[r][t] = a);
            for (t in (y = this.view[r]))
              (a = y[t]), null == (u = s[r])[t] && (u[t] = a);
          }
          for (c = 0, h = (m = j.options).length; c < h; c++)
            s[(r = m[c])] = null != (g = this.component[r]) ? g : this.view[r];
          for (e in ((this.componentView = new j.View(this.el, o, s)),
          this.componentView.bind(),
          (w = []),
          (b = this.observers)))
            (i = b[e]),
              w.push(
                (this.upstreamObservers[e] = this.observe(
                  this.componentView.models,
                  e,
                  (function (n) {
                    return function (t, e) {
                      return function () {
                        return e.setValue(n.componentView.models[t]);
                      };
                    };
                  })(this).call(this, e, i)
                ))
              );
          return w;
        }),
        (a.prototype.unbind = function () {
          var t,
            e,
            n,
            i,
            r = this.upstreamObservers;
          for (t in r) (e = r[t]), e.unobserve();
          for (t in (n = this.observers)) (e = n[t]), e.unobserve();
          return null != (i = this.componentView)
            ? i.unbind.call(this)
            : void 0;
        }),
        a)),
      (j.TextBinding =
        ((e = j.Binding),
        t(o, e),
        (o.prototype.binder = {
          routine: function (t, e) {
            return (t.data = null != e ? e : "");
          },
        }),
        (o.prototype.sync = function () {
          return o.__super__.sync.apply(this, arguments);
        }),
        o)),
      (j.public.binders.text = function (t, e) {
        return null != t.textContent
          ? (t.textContent = null != e ? e : "")
          : (t.innerText = null != e ? e : "");
      }),
      (j.public.binders.html = function (t, e) {
        return (t.innerHTML = null != e ? e : "");
      }),
      (j.public.binders.show = function (t, e) {
        return (t.style.display = e ? "" : "none");
      }),
      (j.public.binders.hide = function (t, e) {
        return (t.style.display = e ? "none" : "");
      }),
      (j.public.binders.enabled = function (t, e) {
        return (t.disabled = !e);
      }),
      (j.public.binders.disabled = function (t, e) {
        return (t.disabled = !!e);
      }),
      (j.public.binders.checked = {
        publishes: !0,
        priority: 2e3,
        bind: function (t) {
          return j.Util.bindEvent(t, "change", this.publish);
        },
        unbind: function (t) {
          return j.Util.unbindEvent(t, "change", this.publish);
        },
        routine: function (t, e) {
          return (t.checked =
            "radio" === t.type
              ? (null != (t = t.value) ? t.toString() : void 0) ===
                (null != e ? e.toString() : void 0)
              : !!e);
        },
      }),
      (j.public.binders.unchecked = {
        publishes: !0,
        priority: 2e3,
        bind: function (t) {
          return j.Util.bindEvent(t, "change", this.publish);
        },
        unbind: function (t) {
          return j.Util.unbindEvent(t, "change", this.publish);
        },
        routine: function (t, e) {
          return (t.checked =
            "radio" === t.type
              ? (null != (t = t.value) ? t.toString() : void 0) !==
                (null != e ? e.toString() : void 0)
              : !e);
        },
      }),
      (j.public.binders.value = {
        publishes: !0,
        priority: 3e3,
        bind: function (t) {
          return "INPUT" !== t.tagName || "radio" !== t.type
            ? ((this.event = "SELECT" === t.tagName ? "change" : "input"),
              j.Util.bindEvent(t, this.event, this.publish))
            : void 0;
        },
        unbind: function (t) {
          return "INPUT" !== t.tagName || "radio" !== t.type
            ? j.Util.unbindEvent(t, this.event, this.publish)
            : void 0;
        },
        routine: function (t, e) {
          var n, i, r, s, o;
          if ("INPUT" === t.tagName && "radio" === t.type)
            return t.setAttribute("value", e);
          if (null != window.jQuery) {
            if (
              ((t = jQuery(t)),
              (null != e ? e.toString() : void 0) !==
                (null != (s = t.val()) ? s.toString() : void 0))
            )
              return t.val(null != e ? e : "");
          } else if ("select-multiple" === t.type) {
            if (null != e) {
              for (o = [], n = 0, i = t.length; n < i; n++)
                (r = t[n]),
                  o.push((r.selected = ((r = r.value), 0 <= d.call(e, r))));
              return o;
            }
          } else if (
            (null != e ? e.toString() : void 0) !==
            (null != (s = t.value) ? s.toString() : void 0)
          )
            return (t.value = null != e ? e : "");
        },
      }),
      (j.public.binders.if = {
        block: !0,
        priority: 4e3,
        bind: function (t) {
          var e, n;
          return null == this.marker
            ? ((e = [this.view.prefix, this.type].join("-").replace("--", "-")),
              (n = t.getAttribute(e)),
              (this.marker = document.createComment(
                " rivets: " + this.type + " " + n + " "
              )),
              (this.bound = !1),
              t.removeAttribute(e),
              t.parentNode.insertBefore(this.marker, t),
              t.parentNode.removeChild(t))
            : void 0;
        },
        unbind: function () {
          var t;
          return null != (t = this.nested) ? t.unbind() : void 0;
        },
        routine: function (t, e) {
          var n, i, r, s;
          if (!!e == !this.bound) {
            if (e) {
              for (n in ((r = {}), (s = this.view.models)))
                (i = s[n]), (r[n] = i);
              return (
                (
                  this.nested ||
                  (this.nested = new j.View(t, r, this.view.options()))
                ).bind(),
                this.marker.parentNode.insertBefore(t, this.marker.nextSibling),
                (this.bound = !0)
              );
            }
            return (
              t.parentNode.removeChild(t),
              this.nested.unbind(),
              (this.bound = !1)
            );
          }
        },
        update: function (t) {
          var e;
          return null != (e = this.nested) ? e.update(t) : void 0;
        },
      }),
      (j.public.binders.unless = {
        block: !0,
        priority: 4e3,
        bind: function (t) {
          return j.public.binders.if.bind.call(this, t);
        },
        unbind: function () {
          return j.public.binders.if.unbind.call(this);
        },
        routine: function (t, e) {
          return j.public.binders.if.routine.call(this, t, !e);
        },
        update: function (t) {
          return j.public.binders.if.update.call(this, t);
        },
      }),
      (j.public.binders["on-*"] = {
        function: !0,
        priority: 1e3,
        unbind: function (t) {
          return this.handler
            ? j.Util.unbindEvent(t, this.args[0], this.handler)
            : void 0;
        },
        routine: function (t, e) {
          return (
            this.handler && j.Util.unbindEvent(t, this.args[0], this.handler),
            j.Util.bindEvent(
              t,
              this.args[0],
              (this.handler = this.eventHandler(e))
            )
          );
        },
      }),
      (j.public.binders["each-*"] = {
        block: !0,
        priority: 4e3,
        bind: function (t) {
          var e, n, i, r;
          if (null == this.marker)
            (e = [this.view.prefix, this.type].join("-").replace("--", "-")),
              (this.marker = document.createComment(
                " rivets: " + this.type + " "
              )),
              (this.iterated = []),
              t.removeAttribute(e),
              t.parentNode.insertBefore(this.marker, t),
              t.parentNode.removeChild(t);
          else
            for (n = 0, i = (r = this.iterated).length; n < i; n++) r[n].bind();
        },
        unbind: function () {
          var t, e, n, i, r;
          if (null != this.iterated) {
            for (r = [], e = 0, n = (i = this.iterated).length; e < n; e++)
              (t = i[e]), r.push(t.unbind());
            return r;
          }
        },
        routine: function (t, e) {
          var n,
            i,
            r,
            s,
            o,
            a,
            u,
            l,
            c,
            d,
            h,
            p,
            f,
            v,
            y,
            m,
            g,
            b,
            w,
            C = this.args[0];
          if (this.iterated.length > (e = e || []).length)
            for (
              d = 0, f = (m = Array(this.iterated.length - e.length)).length;
              d < f;
              d++
            )
              m[d],
                (c = this.iterated.pop()).unbind(),
                this.marker.parentNode.removeChild(c.els[0]);
          for (r = h = 0, v = e.length; h < v; r = ++h)
            if (
              ((o = e[r]),
              ((i = { index: r })[C] = o),
              null == this.iterated[r])
            ) {
              for (s in (g = this.view.models))
                (o = g[s]), null == i[s] && (i[s] = o);
              (u = this.iterated.length
                ? this.iterated[this.iterated.length - 1].els[0]
                : this.marker),
                ((a = this.view.options()).preloadData = !0),
                (l = t.cloneNode(!0)),
                (c = new j.View(l, i, a)).bind(),
                this.iterated.push(c),
                this.marker.parentNode.insertBefore(l, u.nextSibling);
            } else
              this.iterated[r].models[C] !== o && this.iterated[r].update(i);
          if ("OPTION" === t.nodeName) {
            for (w = [], p = 0, y = (b = this.view.bindings).length; p < y; p++)
              (n = b[p]),
                w.push(
                  n.el === this.marker.parentNode && "value" === n.type
                    ? n.sync()
                    : void 0
                );
            return w;
          }
        },
        update: function (t) {
          var e,
            n,
            i,
            r,
            s,
            o,
            a,
            u = {};
          for (e in t) (n = t[e]), e !== this.args[0] && (u[e] = n);
          for (a = [], r = 0, s = (o = this.iterated).length; r < s; r++)
            (i = o[r]), a.push(i.update(u));
          return a;
        },
      }),
      (j.public.binders["class-*"] = function (t, e) {
        var n = " " + t.className + " ";
        return !e == (-1 !== n.indexOf(" " + this.args[0] + " "))
          ? (t.className = e
              ? t.className + " " + this.args[0]
              : n.replace(" " + this.args[0] + " ", " ").trim())
          : void 0;
      }),
      (j.public.binders["*"] = function (t, e) {
        return null != e
          ? t.setAttribute(this.type, e)
          : t.removeAttribute(this.type);
      }),
      (j.public.adapters["."] = {
        id: "_rv",
        counter: 0,
        weakmap: {},
        weakReference: function (t) {
          var e;
          return (
            t.hasOwnProperty(this.id) ||
              ((e = this.counter++),
              Object.defineProperty(t, this.id, { value: e })),
            (e = this.weakmap)[(t = t[this.id])] || (e[t] = { callbacks: {} })
          );
        },
        cleanupWeakReference: function (t, e) {
          return Object.keys(t.callbacks).length ||
            (t.pointers && Object.keys(t.pointers).length)
            ? void 0
            : delete this.weakmap[e];
        },
        stubFunction: function (u, t) {
          var l = u[t],
            c = this.weakReference(u),
            d = this.weakmap;
          return (u[t] = function () {
            var t,
              e,
              n,
              i,
              r,
              s,
              o = l.apply(u, arguments),
              a = c.pointers;
            for (e in a)
              for (
                t = a[e],
                  s =
                    null != (r = null != (r = d[e]) ? r.callbacks[t] : void 0)
                      ? r
                      : [],
                  n = 0,
                  i = s.length;
                n < i;
                n++
              )
                (0, s[n])();
            return o;
          });
        },
        observeMutations: function (t, e, n) {
          var i, r, s, o, a;
          if (Array.isArray(t)) {
            if (null == (r = this.weakReference(t)).pointers)
              for (
                r.pointers = {},
                  o = 0,
                  a = (i = [
                    "push",
                    "pop",
                    "shift",
                    "unshift",
                    "sort",
                    "reverse",
                    "splice",
                  ]).length;
                o < a;
                o++
              )
                this.stubFunction(t, i[o]);
            if (
              (null == (s = r.pointers)[e] && (s[e] = []),
              d.call(r.pointers[e], n) < 0)
            )
              return r.pointers[e].push(n);
          }
        },
        unobserveMutations: function (t, e, n) {
          var i, r;
          return Array.isArray(t) &&
            null != t[this.id] &&
            (i = this.weakmap[t[this.id]]) &&
            (r = i.pointers[e])
            ? (0 <= (n = r.indexOf(n)) && r.splice(n, 1),
              r.length || delete i.pointers[e],
              this.cleanupWeakReference(i, t[this.id]))
            : void 0;
        },
        observe: function (s, o, a) {
          var t,
            u,
            l,
            c = this.weakReference(s).callbacks;
          return (
            null == c[o] &&
              ((c[o] = []),
              (null != (t = Object.getOwnPropertyDescriptor(s, o)) && t.get) ||
                (null != t && t.set) ||
                ((u = s[o]),
                Object.defineProperty(s, o, {
                  enumerable: !0,
                  get: function () {
                    return u;
                  },
                  set:
                    ((l = this),
                    function (t) {
                      var e, n, i, r;
                      if (
                        t !== u &&
                        (l.unobserveMutations(u, s[l.id], o),
                        (u = t),
                        (e = l.weakmap[s[l.id]]))
                      ) {
                        if ((c = e.callbacks)[o])
                          for (n = 0, i = (r = c[o].slice()).length; n < i; n++)
                            (a = r[n]), 0 <= d.call(c[o], a) && a();
                        return l.observeMutations(t, s[l.id], o);
                      }
                    }),
                }))),
            d.call(c[o], a) < 0 && c[o].push(a),
            this.observeMutations(s[o], s[this.id], o)
          );
        },
        unobserve: function (t, e, n) {
          var i, r;
          return (r = this.weakmap[t[this.id]]) && (i = r.callbacks[e])
            ? (0 <= (n = i.indexOf(n)) &&
                (i.splice(n, 1), i.length || delete r.callbacks[e]),
              this.unobserveMutations(t[e], t[this.id], e),
              this.cleanupWeakReference(r, t[this.id]))
            : void 0;
        },
        get: function (t, e) {
          return t[e];
        },
        set: function (t, e, n) {
          return (t[e] = n);
        },
      }),
      (j.factory = function (t) {
        return (j.sightglass = t), (j.public._ = j).public;
      }),
      "object" ==
      typeof ("undefined" != typeof module && null !== module
        ? module.exports
        : void 0)
        ? (module.exports = j.factory(require("sightglass")))
        : "function" == typeof define && define.amd
        ? define(["sightglass"], function (t) {
            return (this.rivets = j.factory(t));
          })
        : (this.rivets = j.factory(sightglass));
  }.call(this),
  function () {
    function e(t, e) {
      return function () {
        return t.apply(e, arguments);
      };
    }
    var n,
      t,
      s,
      o,
      i,
      r,
      u =
        [].indexOf ||
        function (t) {
          for (var e = 0, n = this.length; e < n; e++)
            if (e in this && this[e] === t) return e;
          return -1;
        };
    function a(t) {
      (this.propertyArray = e(this.propertyArray, this)),
        (this.update = e(this.update, this)),
        this.update(t);
    }
    function l() {
      this.update = e(this.update, this);
    }
    (l.prototype.update = function (r) {
      var s, t, e;
      for (t in r) (e = r[t]), "items" !== t && (this[t] = e);
      return (this.items = (function () {
        for (var t = r.items, e = [], n = 0, i = t.length; n < i; n++)
          (s = t[n]), e.push(new o(s));
        return e;
      })());
    }),
      (t = l),
      (a.prototype.update = function (t) {
        var e, n;
        for (e in t) (n = t[e]), "properties" !== e && (this[e] = n);
        return (this.properties = s.Utils.extend({}, t.properties));
      }),
      (a.prototype.propertyArray = function () {
        var t,
          e,
          n = this.properties,
          i = [];
        for (t in n) (e = n[t]), i.push({ name: t, value: e });
        return i;
      }),
      (o = a),
      (s = {
        settings: {
          debug: !1,
          dataAPI: !0,
          requestBodyClass: null,
          rivetsModels: {},
          currency: null,
          moneyFormat: null,
          moneyWithCurrencyFormat: null,
          weightUnit: "g",
          weightPrecision: 0,
        },
        cart: new t(),
        init: function (t, e) {
          return (
            s.configure((e = null == e ? {} : e)),
            s.Utils.log("Initialising CartJS."),
            s.cart.update(t),
            s.settings.dataAPI &&
              (s.Utils.log('"dataAPI" setting is true, initialising Data API.'),
              s.Data.init()),
            s.settings.requestBodyClass &&
              (s.Utils.log('"requestBodyClass" set, adding event listeners.'),
              jQuery(document).on("cart.requestStarted", function () {
                return jQuery("body").addClass(s.settings.requestBodyClass);
              }),
              jQuery(document).on("cart.requestComplete", function () {
                return jQuery("body").removeClass(s.settings.requestBodyClass);
              })),
            s.Rivets.init(),
            jQuery(document).trigger("cart.ready", [s.cart])
          );
        },
        configure: function (t) {
          return s.Utils.extend(s.settings, (t = null == t ? {} : t));
        },
      }),
      null == window.console &&
        ((window.console = {}), (window.console.log = function () {})),
      (s.Utils = {
        log: function () {
          return s.Utils.console(console.log, arguments);
        },
        warn: function () {
          return s.Utils.console(console.warn, arguments);
        },
        error: function () {
          return s.Utils.console(console.error, arguments);
        },
        console: function (t, e) {
          return s.settings.debug &&
            "undefined" != typeof console &&
            null !== console
            ? ((e = Array.prototype.slice.call(e)).unshift("[CartJS]:"),
              t.apply(console, e))
            : void 0;
        },
        wrapKeys: function (t, e, n, i) {
          var r, s, o, a;
          for (r in (null == e && (e = "properties"),
          null == i && (i = []),
          (a = {}),
          t))
            (o = t[r]),
              (s = 0 <= u.call(i, r) ? r : e + "[" + r + "]"),
              (a[s] = null != n ? n : o);
          return a;
        },
        unwrapKeys: function (t, e, n) {
          var i, r, s, o;
          for (i in (null == e && (e = "properties"), (r = {}), t))
            (o = t[i]),
              (s = i.replace(e + "[", "").replace("]", "")),
              (r[s] = null != n ? n : o);
          return r;
        },
        extend: function (t, e) {
          var n, i;
          for (n in e) (i = e[n]), (t[n] = i);
          return t;
        },
        clone: function (t) {
          var e, n;
          if (null == t || "object" != typeof t) return t;
          for (e in ((n = new t.constructor()), t)) n[e] = clone(t[e]);
          return n;
        },
        delete: function (t, e) {
          var n = t[e];
          return delete t[e], n;
        },
        isArray:
          Array.isArray ||
          function (t) {
            return "[object Array]" === {}.toString.call(t);
          },
        ensureArray: function (t) {
          return s.Utils.isArray(t) ? t : null != t ? [t] : [];
        },
        formatMoney: function (t, e, n, i) {
          var r;
          return (
            (i = (i = null == i ? "" : i) || s.settings.currency),
            null != window.Currency &&
              i !== s.settings.currency &&
              ((t = Currency.convert(t, s.settings.currency, i)),
              null !=
                (null != (r = window.Currency) ? r.moneyFormats : void 0)) &&
              i in window.Currency.moneyFormats &&
              (e = window.Currency.moneyFormats[i][n]),
            null != (null != (r = window.Shopify) ? r.formatMoney : void 0)
              ? Shopify.formatMoney(t, e)
              : (s.Utils.warn(
                  'A money formatting filter was used, but Shopify.formatMoney is not available. See the note "Dependency when formatting monetary values" on this page: https://cartjs.org/pages/guide#getting-started-setup.'
                ),
                t)
          );
        },
        getSizedImageUrl: function (t, e) {
          var n;
          return null !=
            (null != (n = window.Shopify) && null != (n = n.Image)
              ? n.getSizedImageUrl
              : void 0)
            ? t
              ? Shopify.Image.getSizedImageUrl(t, e)
              : Shopify.Image.getSizedImageUrl(
                  "https://cdn.shopify.com/s/images/admin/no-image-.gif",
                  e
                ).replace("-_", "-")
            : t || "https://cdn.shopify.com/s/images/admin/no-image-large.gif";
        },
      }),
      (i = !(r = [])),
      (s.Queue = {
        add: function (t, e, n) {
          t = {
            url: t,
            data: e,
            type: (n = null == n ? {} : n).type || "POST",
            dataType: n.dataType || "json",
            cache: !!n.cache,
            success: s.Utils.ensureArray(n.success),
            error: s.Utils.ensureArray(n.error),
            complete: s.Utils.ensureArray(n.complete),
          };
          return (
            n.updateCart && t.success.push(s.cart.update),
            r.push(t),
            i
              ? void 0
              : (jQuery(document).trigger("cart.requestStarted", [s.cart]),
                s.Queue.process())
          );
        },
        process: function () {
          var t;
          return r.length
            ? ((i = !0),
              ((t = r.shift()).complete = s.Queue.process),
              jQuery.ajax(t))
            : ((i = !1),
              void jQuery(document).trigger("cart.requestComplete", [s.cart]));
        },
      }),
      (s.Core = {
        getCart: function (t) {
          return (
            ((t = null == t ? {} : t).type = "GET"),
            (t.updateCart = !0),
            s.Queue.add("/cart.js", { v: new Date().getTime() }, t)
          );
        },
        addItem: function (t, e, n, i) {
          return (
            null == e && (e = 1),
            null == i && (i = {}),
            ((n = s.Utils.wrapKeys((n = null == n ? {} : n), null, null, [
              "selling_plan",
            ])).id = t),
            (n.quantity = e),
            s.Queue.add("/cart/add.js", n, i),
            s.Core.getCart()
          );
        },
        addItems: function (t, e) {
          return (
            s.Queue.add("/cart/add.js", { items: t }, (e = null == e ? {} : e)),
            s.Core.getCart()
          );
        },
        updateItem: function (t, e, n, i) {
          return (
            null == i && (i = {}),
            ((n = s.Utils.wrapKeys((n = null == n ? {} : n), null, null, [
              "selling_plan",
            ])).line = t),
            null != e && (n.quantity = e),
            (i.updateCart = !0),
            s.Queue.add("/cart/change.js", n, i)
          );
        },
        removeItem: function (t, e) {
          return s.Core.updateItem(t, 0, {}, (e = null == e ? {} : e));
        },
        updateItemById: function (t, e, n, i) {
          return (
            null == i && (i = {}),
            ((n = s.Utils.wrapKeys((n = null == n ? {} : n), null, null, [
              "selling_plan",
            ])).id = t),
            null != e && (n.quantity = e),
            (i.updateCart = !0),
            s.Queue.add("/cart/change.js", n, i)
          );
        },
        updateItemQuantitiesById: function (t, e) {
          return (
            null == t && (t = {}),
            ((e = null == e ? {} : e).updateCart = !0),
            s.Queue.add("/cart/update.js", { updates: t }, e)
          );
        },
        removeItemById: function (t, e) {
          t = { id: t, quantity: 0 };
          return (
            ((e = null == e ? {} : e).updateCart = !0),
            s.Queue.add("/cart/change.js", t, e)
          );
        },
        clear: function (t) {
          return (
            ((t = null == t ? {} : t).updateCart = !0),
            s.Queue.add("/cart/clear.js", {}, t)
          );
        },
        getAttribute: function (t, e) {
          return t in s.cart.attributes ? s.cart.attributes[t] : e;
        },
        setAttribute: function (t, e, n) {
          var i;
          return (
            null == n && (n = {}), ((i = {})[t] = e), s.Core.setAttributes(i, n)
          );
        },
        getAttributes: function () {
          return s.cart.attributes;
        },
        setAttributes: function (t, e) {
          return (
            null == t && (t = {}),
            ((e = null == e ? {} : e).updateCart = !0),
            s.Queue.add("/cart/update.js", s.Utils.wrapKeys(t, "attributes"), e)
          );
        },
        clearAttributes: function (t) {
          return (
            ((t = null == t ? {} : t).updateCart = !0),
            s.Queue.add(
              "/cart/update.js",
              s.Utils.wrapKeys(s.Core.getAttributes(), "attributes", ""),
              t
            )
          );
        },
        getNote: function () {
          return s.cart.note;
        },
        setNote: function (t, e) {
          return (
            ((e = null == e ? {} : e).updateCart = !0),
            s.Queue.add("/cart/update.js", { note: t }, e)
          );
        },
      }),
      (n = null),
      (s.Data = {
        init: function () {
          return (
            (n = jQuery(document)),
            s.Data.setEventListeners("on"),
            s.Data.render(null, s.cart)
          );
        },
        destroy: function () {
          return s.Data.setEventListeners("off");
        },
        setEventListeners: function (t) {
          return (
            n[t]("click", "[data-cart-add]", s.Data.add),
            n[t]("click", "[data-cart-remove]", s.Data.remove),
            n[t]("click", "[data-cart-remove-id]", s.Data.removeById),
            n[t]("click", "[data-cart-update]", s.Data.update),
            n[t]("click", "[data-cart-update-id]", s.Data.updateById),
            n[t]("click", "[data-cart-clear]", s.Data.clear),
            n[t]("change", "[data-cart-toggle]", s.Data.toggle),
            n[t](
              "change",
              "[data-cart-toggle-attribute]",
              s.Data.toggleAttribute
            ),
            n[t]("submit", "[data-cart-submit]", s.Data.submit),
            n[t]("cart.requestComplete", s.Data.render)
          );
        },
        add: function (t) {
          var e;
          return (
            t.preventDefault(),
            (t = jQuery(this)),
            ((e = {}).selling_plan = t.attr("data-cart-selling-plan")),
            s.Core.addItem(
              t.attr("data-cart-add"),
              t.attr("data-cart-quantity"),
              e
            )
          );
        },
        remove: function (t) {
          return (
            t.preventDefault(),
            (t = jQuery(this)),
            s.Core.removeItem(t.attr("data-cart-remove"))
          );
        },
        removeById: function (t) {
          return (
            t.preventDefault(),
            (t = jQuery(this)),
            s.Core.removeItemById(t.attr("data-cart-remove-id"))
          );
        },
        update: function (t) {
          var e;
          return (
            t.preventDefault(),
            (t = jQuery(this)),
            ((e = {}).selling_plan = t.attr("data-cart-selling-plan")),
            s.Core.updateItem(
              t.attr("data-cart-update"),
              t.attr("data-cart-quantity"),
              e
            )
          );
        },
        updateById: function (t) {
          var e;
          return (
            t.preventDefault(),
            (t = jQuery(this)),
            ((e = {}).selling_plan = t.attr("data-cart-selling-plan")),
            s.Core.updateItemById(
              t.attr("data-cart-update-id"),
              t.attr("data-cart-quantity"),
              e
            )
          );
        },
        clear: function (t) {
          return t.preventDefault(), s.Core.clear();
        },
        toggle: function () {
          var t = jQuery(this),
            e = t.attr("data-cart-toggle");
          return t.is(":checked")
            ? s.Core.addItem(e)
            : s.Core.removeItemById(e);
        },
        toggleAttribute: function () {
          var t = jQuery(this),
            e = t.attr("data-cart-toggle-attribute");
          return s.Core.setAttribute(e, t.is(":checked") ? "Yes" : "");
        },
        submit: function (t) {
          var n, i, r;
          return (
            t.preventDefault(),
            (t = jQuery(this).serializeArray()),
            (r = n = void 0),
            (i = {}),
            jQuery.each(t, function (t, e) {
              return "id" === e.name
                ? (n = e.value)
                : "quantity" === e.name
                ? (r = e.value)
                : "selling_plan" === e.name
                ? (i.selling_plan = e.value)
                : e.name.match(/^properties\[[\w-_ ]*\]$/)
                ? (i[e.name] = e.value)
                : void 0;
            }),
            s.Core.addItem(n, r, s.Utils.unwrapKeys(i))
          );
        },
        render: function (t, e) {
          var n = {
            item_count: e.item_count,
            total_price: e.total_price,
            total_price_money: s.Utils.formatMoney(
              e.total_price,
              s.settings.moneyFormat,
              "money_format",
              null !=
                ("undefined" != typeof Currency && null !== Currency
                  ? Currency.currentCurrency
                  : void 0)
                ? Currency.currentCurrency
                : void 0
            ),
            total_price_money_with_currency: s.Utils.formatMoney(
              e.total_price,
              s.settings.moneyWithCurrencyFormat,
              "money_with_currency_format",
              null !=
                ("undefined" != typeof Currency && null !== Currency
                  ? Currency.currentCurrency
                  : void 0)
                ? Currency.currentCurrency
                : void 0
            ),
          };
          return jQuery("[data-cart-render]").each(function () {
            var t = jQuery(this);
            return t.html(n[t.attr("data-cart-render")]);
          });
        },
      }),
      "undefined" != typeof rivets && null !== rivets
        ? ((s.Rivets = {
            model: null,
            boundViews: [],
            init: function () {
              return s.Rivets.bindViews();
            },
            destroy: function () {
              return s.Rivets.unbindViews();
            },
            bindViews: function () {
              return (
                s.Utils.log("Rivets.js is present, binding views."),
                s.Rivets.unbindViews(),
                (s.Rivets.model = s.Utils.extend(
                  { cart: s.cart },
                  s.settings.rivetsModels
                )),
                null != window.Currency &&
                  (s.Rivets.model.Currency = window.Currency),
                jQuery("[data-cart-view]").each(function () {
                  var t = rivets.bind(jQuery(this), s.Rivets.model);
                  return s.Rivets.boundViews.push(t);
                })
              );
            },
            unbindViews: function () {
              for (var t = s.Rivets.boundViews, e = 0, n = t.length; e < n; e++)
                t[e].unbind();
              return (s.Rivets.boundViews = []);
            },
          }),
          (rivets.formatters.eq = function (t, e) {
            return t === e;
          }),
          (rivets.formatters.includes = function (t, e) {
            return 0 <= t.indexOf(e);
          }),
          (rivets.formatters.match = function (t, e, n) {
            return t.match(new RegExp(e, n));
          }),
          (rivets.formatters.lt = function (t, e) {
            return t < e;
          }),
          (rivets.formatters.gt = function (t, e) {
            return e < t;
          }),
          (rivets.formatters.not = function (t) {
            return !t;
          }),
          (rivets.formatters.empty = function (t) {
            return !t.length;
          }),
          (rivets.formatters.plus = function (t, e) {
            return parseInt(t) + parseInt(e);
          }),
          (rivets.formatters.minus = function (t, e) {
            return parseInt(t) - parseInt(e);
          }),
          (rivets.formatters.times = function (t, e) {
            return t * e;
          }),
          (rivets.formatters.divided_by = function (t, e) {
            return t / e;
          }),
          (rivets.formatters.modulo = function (t, e) {
            return t % e;
          }),
          (rivets.formatters.prepend = function (t, e) {
            return e + t;
          }),
          (rivets.formatters.append = function (t, e) {
            return t + e;
          }),
          (rivets.formatters.slice = function (t, e, n) {
            return t.slice(e, n);
          }),
          (rivets.formatters.pluralize = function (t, e, n) {
            return (
              null == n && (n = e + "s"),
              1 === (t = s.Utils.isArray(t) ? t.length : t) ? e : n
            );
          }),
          (rivets.formatters.array_element = function (t, e) {
            return t[e];
          }),
          (rivets.formatters.array_first = function (t) {
            return t[0];
          }),
          (rivets.formatters.array_last = function (t) {
            return t[t.length - 1];
          }),
          (rivets.formatters.money = function (t, e) {
            return s.Utils.formatMoney(
              t,
              s.settings.moneyFormat,
              "money_format",
              e
            );
          }),
          (rivets.formatters.money_with_currency = function (t, e) {
            return s.Utils.formatMoney(
              t,
              s.settings.moneyWithCurrencyFormat,
              "money_with_currency_format",
              e
            );
          }),
          (rivets.formatters.weight = function (t) {
            switch (s.settings.weightUnit) {
              case "kg":
                return (t / 1e3).toFixed(s.settings.weightPrecision);
              case "oz":
                return (0.035274 * t).toFixed(s.settings.weightPrecision);
              case "lb":
                return (0.00220462 * t).toFixed(s.settings.weightPrecision);
              default:
                return t.toFixed(s.settings.weightPrecision);
            }
          }),
          (rivets.formatters.weight_with_unit = function (t) {
            return rivets.formatters.weight(t) + s.settings.weightUnit;
          }),
          (rivets.formatters.product_image_size = function (t, e) {
            return s.Utils.getSizedImageUrl(t, e);
          }),
          (rivets.formatters.moneyWithCurrency =
            rivets.formatters.money_with_currency),
          (rivets.formatters.weightWithUnit =
            rivets.formatters.weight_with_unit),
          (rivets.formatters.productImageSize =
            rivets.formatters.product_image_size))
        : (s.Rivets = { init: function () {}, destroy: function () {} }),
      (s.factory = function (t) {
        return (
          (t.init = s.init),
          (t.configure = s.configure),
          (t.cart = s.cart),
          (t.settings = s.settings),
          (t.getCart = s.Core.getCart),
          (t.addItem = s.Core.addItem),
          (t.addItems = s.Core.addItems),
          (t.updateItem = s.Core.updateItem),
          (t.updateItemById = s.Core.updateItemById),
          (t.updateItemQuantitiesById = s.Core.updateItemQuantitiesById),
          (t.removeItem = s.Core.removeItem),
          (t.removeItemById = s.Core.removeItemById),
          (t.clear = s.Core.clear),
          (t.getAttribute = s.Core.getAttribute),
          (t.setAttribute = s.Core.setAttribute),
          (t.getAttributes = s.Core.getAttributes),
          (t.setAttributes = s.Core.setAttributes),
          (t.clearAttributes = s.Core.clearAttributes),
          (t.getNote = s.Core.getNote),
          (t.setNote = s.Core.setNote),
          (t.render = s.Data.render)
        );
      }),
      "object" == typeof exports
        ? s.factory(exports)
        : "function" == typeof define && define.amd
        ? define(["exports"], function (t) {
            return s.factory((this.CartJS = t)), t;
          })
        : s.factory((this.CartJS = {}));
  }.call(this),
  jQuery(function () {
    function r() {
      $("body").addClass("has-popup-open"),
        $("#popup-cart").addClass("is-active");
    }
    $.ajax({
      type: "GET",
      url: "/cart.js",
      cache: !1,
      dataType: "json",
      success: function (t) {
        CartJS.init(t, {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "${{amount}} USD",
          requestBodyClass: "cart-loading",
        });
      },
    }),
      initSearchOpener(),
      $(".trigger-el").on("focus", function () {
        $(this)
          .closest("form")
          .find(".form-subscribe__btn")
          .removeClass("hidden");
      }),
      jQuery("#FootNewsletter").on("submit", function (t) {
        t.preventDefault();
        t = jQuery("#emailfooterinp").val();
        validateEmail(t)
          ? (jQuery("#FootNewsletter .err-message")
              .hide()
              .removeClass("reveal"),
            jQuery.ajax({
              url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
              method: "POST",
              crossDomain: !0,
              dataType: "json",
              data: {
                g: "XQRfes",
                $fields: "$source,$consent",
                $consent: "web",
                signup_location: "Footer",
                email: t,
                $source: "Website",
              },
              success: function (t) {
                jQuery("#FootNewsletter .hdme").hide(),
                  jQuery("#FootNewsletter .success-message ").fadeIn(),
                  jQuery("#FootNewsletter").find("input[type=email]").val(" ");
              },
            }))
          : jQuery("#FootNewsletter .err-message").fadeIn();
      }),
      window.addEventListener(
        "hashchange",
        function () {
          "#view-cart" === window.location.hash && r();
        },
        !1
      ),
      "#view-cart" === window.location.hash && r(),
      $(document).on("click", ".js-add-to-bag", function (t) {
        t.preventDefault();
        var i = $(this).data("product-id"),
          t = ($(this).data("bogo-id"), $(this).data("quantity")),
          e = ($(this).data("sale-oprice"), $(this).data("selling_plan")),
          n = [];
        i &&
          (n.push(
            e
              ? {
                  id: i,
                  quantity: t,
                  selling_plan: e,
                  properties: {
                    _cd1: cl1,
                    _cd2: cl2,
                    _issub: "Monthly Subscription",
                  },
                }
              : { id: i, quantity: t }
          ),
          CartJS.addItems(n, {
            success: function (t, e, n) {
              setTimeout(function () {
                r();
              }, 350),
                $(document).trigger("product-added", [i]),
                $.getJSON("/cart.js", function (t) {
                  t = {
                    total_price: t.total_price / 100,
                    $value: t.total_price / 100,
                    total_discount: t.total_discount,
                    original_total_price: t.original_total_price / 100,
                    items: t.items,
                  };
                  klaviyo.push(["track", "Added to Cart", t]);
                });
            },
            error: function (t, e, n) {
              $btn.text(orig_text);
            },
          }));
      }),
      $(document).on("cart.ready", function (t, e) {}),
      $(document).on("cart.requestComplete", function (t, e) {
        var n, i, r;
        (r = []),
          (e = e) &&
            0 < e.items.length &&
            ($.each(e.items, function (t, e) {
              r.push(e.id);
            }),
            (n = jQuery("#free-gift-data-holder").data("id")),
            (i = jQuery("#free-gift-data-holder").data("min")),
            0 != n) &&
            (e.total_price >= 100 * i
              ? n && -1 === jQuery.inArray(n, r) && CartJS.addItem(n, 1, {})
              : -1 != jQuery.inArray(n, r) && CartJS.removeItemById(n));
      });
    var t = [...document.querySelectorAll("video.lazy")];
    if ("IntersectionObserver" in window) {
      let n = new IntersectionObserver(function (t) {
        t.forEach(function (t) {
          if (t.isIntersecting) {
            for (var e in t.target.children) {
              e = t.target.children[e];
              "string" == typeof e.tagName &&
                "SOURCE" === e.tagName &&
                (e.src = e.dataset.src);
            }
            t.target.load(),
              t.target.classList.remove("lazy"),
              n.unobserve(t.target);
          }
        });
      });
      t.forEach(function (t) {
        n.observe(t);
      });
    }
  });
jQuery("video").on("click", function (e) {
  e.stopPropagation();
  jQuery(this).closest(".js-video-player").toggleClass("is-playing");
  if (jQuery(this).closest(".swiper-thumbs").length <= 0) {
    if (this.paused) {
      this.play();
    } else {
      this.pause();
    }
  }
});

jQuery(".js-play").on("click", function (e) {
  e.stopPropagation();
  if (jQuery(this).closest(".swiper-thumbs").length <= 0) {
    jQuery(this).closest(".js-video-player").toggleClass("is-playing");
    let video = jQuery(this).closest(".js-video-player").find("video").get(0);
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }
});

const hideUpsellDropdown = setInterval(() => {
  $(".upsellplus-selection").each(function () {
    if (
      $(this).children("option").length === 1 &&
      !$(this).data("processed")
    ) {
      const value = $(this).val(); // Get the only option's value

      // Insert the value into a nearby span or create one if needed
      let $textSpan = $(this).siblings(".upsell-size-text");
      if ($textSpan.length === 0) {
        $textSpan = $('<span class="upsell-size-text"></span>');
        $(this).after($textSpan); // insert right after the <select>
      }
      $textSpan.text(value);

      // Hide the select or its wrapper
      const wrapper = $(this).closest(".selector-wrapper");
      if (wrapper.length) {
        wrapper.hide();
      } else {
        $(this).hide();
      }

      $(this).data("processed", true);
    }
  });
}, 300);
